// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1bVJs","colMin":"styles_colMin__1xTpd","colCheckbox":"styles_colCheckbox__2qXRV"};